import { combineReducers } from "redux";
import app_setup from "../features/admin/app_setup/Slice";

const AllAppsetupData = combineReducers({
  app_setup: app_setup,
});

export default AllAppsetupData;
